/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1OverviewModel } from '../../entities/v1/OverviewModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const v1OverviewModelSchema = z.object({
  company_reward: z.number(),
  drivee_commission: z.number(),
  drivers_revenue: z.number(),
  total_orders: z.number().int(),
}) as unknown as ToZod<V1OverviewModel>